import React, { useState } from 'react';
import { Button } from './ui/button';
import { Settings, LogOut, ChevronDown } from 'lucide-react';

const UserMenu = ({ user, onShowSettings, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!user) {
    return (
      <Button variant="outline" className="bg-blue-500 text-white hover:bg-blue-600">
        Sign In
      </Button>
    );
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 p-1 rounded-full hover:bg-gray-800 transition-colors"
      >
        <div className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center text-white font-bold text-sm">
          {(user?.full_name?.charAt(0) || '?').toUpperCase()}
        </div>
        <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)}></div>
          <div className="absolute right-0 top-full mt-2 w-64 bg-gray-900 border border-gray-800 rounded-lg shadow-xl z-20">
            <div className="p-3 border-b border-gray-800">
              <p className="font-semibold text-sm text-white">{user?.full_name}</p>
              <p className="text-xs text-gray-400">{user?.email}</p>
            </div>
            <div className="p-2">
              <button
                onClick={() => { onShowSettings(); setIsOpen(false); }}
                className="w-full flex items-center space-x-2 px-2 py-1.5 text-sm text-left text-gray-300 hover:bg-gray-800 rounded-md"
              >
                <Settings className="w-4 h-4" />
                <span>Account Settings</span>
              </button>
              <button
                onClick={() => { onLogout(); setIsOpen(false); }}
                className="w-full flex items-center space-x-2 px-2 py-1.5 text-sm text-left text-red-400 hover:bg-gray-800 rounded-md"
              >
                <LogOut className="w-4 h-4" />
                <span>Sign Out</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserMenu;